module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "check",
    class: {
      selected: _vm.selected
    },
    on: {
      "click": function($event) {
        _vm.updateSelected()
      }
    }
  }, [_vm._c('div', {
    staticClass: "icon"
  }, [(!_vm.selected) ? _vm._c('i', {
    staticClass: "far fa-square"
  }) : _vm._e(), _vm._v(" "), (_vm.selected) ? _vm._c('i', {
    staticClass: "fas fa-check-square"
  }) : _vm._e()]), _vm._v(" "), _vm._c('span', [_vm._v(_vm._s(_vm.chapter.title))]), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0735523a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/file-exporter/ChapterRow.vue
// module id = 615
// module chunks = 1